export const AUDIT_LOG_KEYS = {
  AMOUNT: "amount",
  DATE: "date",
  INVOICE: "invoice",
  COMMENT: "comment",
  TRANSACTION: "transaction",
  STATUS: "status",
  NOTE: "note",
  TAG: "tag",
} as const;

export type AuditLogKey = (typeof AUDIT_LOG_KEYS)[keyof typeof AUDIT_LOG_KEYS];
